import { useEffect } from "react"
import PubSub from "pubsub-js"
import rt, { disconnectSocket } from "aldoo-ra/Realtime"
import PlatformAuth from "aldoo-ra/PlatformAuth"

// Bridges the /rt/account Socket.io namespace to PubSub topics so the
// account panels (Your Files, Usage) patch without a refresh.
//
// PubSub topics:
//   snap.created / snap.uploaded / snap.viewed / snap.downloaded / snap.deleted
//   snap.files.changed — catch-all fired for every event above

const SNAP_EVENTS = [
    "snap.created", "snap.uploaded", "snap.viewed", "snap.downloaded", "snap.deleted",
]
// License seat changes — published under their own topic (no files catch-all).
// membership_changed targets the affected (removed/added) user's session;
// devices_changed targets the owner's management UI.
const LICENSE_EVENTS = ["license.devices_changed", "license.membership_changed"]

export default function useSnapRealtime() {
    const [auth] = PlatformAuth.useAuth()
    useEffect(() => {
        if (!auth?._id) return
        let socket
        try {
            socket = rt("account")
        } catch {
            return
        }
        const offs = []
        for (const event of SNAP_EVENTS) {
            const handler = (payload) => {
                PubSub.publish(event, payload)
                PubSub.publish("snap.files.changed", { event, payload })
            }
            socket.on(event, handler)
            offs.push(() => socket.off(event, handler))
        }
        for (const event of LICENSE_EVENTS) {
            const handler = (payload) => PubSub.publish(event, payload)
            socket.on(event, handler)
            offs.push(() => socket.off(event, handler))
        }
        return () => {
            for (const off of offs) try { off() } catch { }
            // Keep the socket alive across remounts in the same Account
            // tree — only fully disconnect when auth flips.
        }
    }, [auth?._id])

    useEffect(() => () => { try { disconnectSocket("account") } catch { } }, [])
}
